import React from "react";
import { Switch, Route } from "react-router-dom";
import ParnerPreference from "./PartnerPreference";
import Home from "./Home";
import Privacy from "./Privacy";
import Settings from "./Settings";
import NotFound from "../NotFound";
const Profile = ({ match, updateHeader, updateBreadcrumb }) => {
  return (
    <Switch>
      <Route
        path={`${match.url}/partner-preference`}
        exact
        render={props => (
          <ParnerPreference
            updateHeader={updateHeader}
            updateBreadcrumb={updateBreadcrumb}
          />
        )}
      />

      <Route
        path={`${match.url}/privacy`}
        exact
        render={props => (
          <Privacy
            updateHeader={updateHeader}
            updateBreadcrumb={updateBreadcrumb}
          />
        )}
      />
      <Route
        path={`${match.url}/settings`}
        exact
        render={props => (
          <Settings
            updateHeader={updateHeader}
            updateBreadcrumb={updateBreadcrumb}
          />
        )}
      />
      <Route
        path={`${match.url}`}
        exact
        render={({ location }) => (
          <Home
            updateHeader={updateHeader}
            updateBreadcrumb={updateBreadcrumb}
            location={location}
          />
        )}
      />
      <Route
        render={props => (
          <NotFound
            updateHeader={updateHeader}
            updateBreadcrumb={updateBreadcrumb}
          />
        )}
      />
    </Switch>
  );
};

export default Profile;



// WEBPACK FOOTER //
// ./src/_components/Profile/index.js